import React, { useEffect, useRef, useState } from "react";
import "./UserActivity.scss";
import { FaRegEdit } from "react-icons/fa";
import { MdNotificationsNone, MdOutlineDelete } from "react-icons/md";
import { useQuery } from "@tanstack/react-query";
import {
  deleteProject,
  getAddNewTaskDetail,
  getOnGoingTask,
  getOverDueTask,
  getReports,
  getTableData,
  getUnderReviewTask,
  getUpComingTask,
  getUserActivity,
  listOfProject,
  removeTask,
} from "../../apiCall";
import { CgAttachment } from "react-icons/cg";
import toast from "react-hot-toast";
import { ConfirmationModal } from "../../components/Modals/ConfirmationModal";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useStateValue } from "../../StateProvider";
import { isAdmin } from "../../utils/adminAccess";
import {
  getClassNamesOfEndDate,
  getClassNamesOfStartDate,
  getClassNamesOfStatus,
} from "../../utils/colorCode";
import { IoMdSearch } from "react-icons/io";
import { formatDateTimetoAmPm, formatTimeDuration } from "../../utils/FormateDate";
import { useForm } from "react-hook-form";
import { generateActiveLogExcel, generateExcel, getEntityValueById } from "../../utils/downloadReports";
import { ACTION_TYPE, ENTITY_TYPE } from "../../Constants";
import { convertToUserOptions, customStyles } from "../../utils/ConvertToOptions";
import Select from 'react-select'



function capitalizeFirstLetterOfEachWord(str) {
  return str
    .split(' ') // Split the string by spaces into an array of words
    .map(word => word.charAt(0).toUpperCase() + word.slice(1)) // Capitalize the first letter of each word
    .join(' '); // Join the array back into a single string
}
const UserActivity = () => {
  const [{ sysConfig, userInfo }, dispatch] = useStateValue();

  const navigate = useNavigate();

  const transformedArray = (inputArray) => {
    if (inputArray) {
      const output = inputArray.map((obj) => {
        const key = Object.keys(obj)[0];
        const value = obj[key];
        return { id: key, value: value };
      });
      return output;
    }
    return [];
  };

  // ********************************************************************* filter Data *************************************************
  const [searchQuery, setSearchQuery] = useState("");
  const [userFilter, setUserFilter] = useState("");
  const [entityFilter, setEntityFilter] = useState("");
  const [isStatusFilter, setIsStatusFilter] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [filteredData, setFilteredData] = useState([]);
  const [currentItems, setCurrentItems] = useState([]);
  const searchInput = useRef(null);
  const [totalPages, setTotalPages] = useState(0);
  const fetchReport = async (userFilter) => {
    // Perform the API call to fetch company info
    dispatch({ type: "SET_LOADING", status: true });

    try {
      const response = await listOfProject(userFilter);
      if (response?.status === 200) {
        // setReportData(response.data.data);
        // setFilteredData(response.data.data);
      } else if (response?.response?.status) {
        toast.error("Something went wrong.");
      }
    } catch (error) {
      console.error("Error fetching data:", error); // Log any errors that occur
      throw error;
    }
    dispatch({ type: "SET_LOADING", status: false });
  };

  const { isLoading, data, refetch } = useQuery({
    queryKey: ["report-list", userFilter],
    queryFn: () => fetchReport(userFilter),
    enabled: false,
    onSuccess: (Re) => {
      console.log(Re);
    },
    onError: (e) => {
      console.log(e);
    },
  });
  const [reportData, setReportData] = useState([]);
  const {
    isLoading: isUserListLoading,
    data: useList,
    refetch: userListreFetch,
  } = useQuery({
    queryKey: ["new-task--form-data"],
    queryFn: async () => {
      // Perform the API call to fetch company info
      try {
        dispatch({ type: "SET_LOADING", status: true });

        const response = await getAddNewTaskDetail();
        if (response?.status === 200) {
          setUserList(response.data.data.users_list);
          setTaskStatusFilter(transformedArray(response.data.data.status_list));

        } else if (response?.response) {
          toast.error(response.response.data.status);
        }
        dispatch({ type: "SET_LOADING", status: false });

        return response;
      } catch (error) {
        console.error("Error fetching data:", error); // Log any errors that occur
        throw error;
      }
    },
    // enabled: isAdmin(userInfo) ? true : false,
  });
  const [userList, setUserList] = useState(
    data?.status === 200 ? data.data.data.users_list : []
  );
  const [totalTaskData, setTotalTaskData] = useState({});

  const {
    register,
    handleSubmit,
    setValue,
    reset,
    watch,
    formState: { errors },
  } = useForm({
    defaultValues: {
      entityId: 0

    },
  });

  const watchedFields = watch();
  const onSubmit = async (data) => {
    console.log("asdasdadsad")

    if (!(watchedFields.startDate && watchedFields.endDate)) {
      toast.error("Please select start date and end date.")
    }
    else if (watchedFields.startDate && !watchedFields.endDate) {
      toast.error("Please select end date.")
    }
    else if (watchedFields.endDate && !watchedFields.startDate) {
      toast.error("Please select start date.")

    }
    else if (watchedFields.startDate && watchedFields.endDate) {
      const start = new Date(data.startDate);
      const end = new Date(data.endDate);
      const diffInMs = end - start;
      // Convert the difference from milliseconds to days
      const diffInDays = diffInMs / (1000 * 60 * 60 * 24);
      if (diffInDays > parseInt(sysConfig["Report Days Upto"])) {
        start.setDate(start.getUTCDate() + parseInt(sysConfig["Report Days Upto"]))


        toast.error(`Maximum end date can be ${start.toISOString().split('T')[0]}`)
      }

      else {
        // **************************** convert duration end ****************************

        dispatch({ type: "SET_LOADING", status: true });
        try {
          const re = await getUserActivity(data);
          console.log(re)

          if (re?.status === 200) {

            setReportData(re.data.data);
            setFilteredData(re.data.data);
            // }
            setReportStatus(data.reportStatus)
            setEntityType(data.entity)
            setAppliedFilter(data)


            setTitle(capitalizeFirstLetterOfEachWord(`${data.userFilter} ${data.actionType} ${getEntityValueById(data.entityType)}  Activity`))

            if ((buttonRef.current && re.data.data.length > 0) || data.reportStatus === "task_totals") {
              buttonRef.current.click();
            }
          }
          else if (re?.response) {
            setReportData([]);
            setFilteredData([]);
            setReportStatus(data.reportStatus)
            toast.error(re.response.data.message)
          }
        } catch { }
        dispatch({ type: "SET_LOADING", status: false });
      }
    }



  };
  useEffect(() => {
    filterData(searchQuery);
    setCurrentPage(1);
  }, [searchQuery]);

  useEffect(() => {
    const startIdx =
      (currentPage - 1) * Number(sysConfig["Rows in MultiLine List"]);
    setCurrentItems(
      filteredData.slice(
        startIdx,
        startIdx + Number(sysConfig["Rows in MultiLine List"])
      )
    );
    console.log("dDddddddddddddddddddddd", filteredData.slice(
      startIdx,
      startIdx + Number(sysConfig["Rows in MultiLine List"])
    ))
    setTotalPages(
      Math.ceil(
        filteredData.length / Number(sysConfig["Rows in MultiLine List"])
      )
    );
  }, [currentPage, filteredData]);

  useEffect(() => {
    filterData(searchQuery, userFilter, isStatusFilter);
    const totalPageCount = Math.ceil(
      filteredData.length / Number(sysConfig["Rows in MultiLine List"])
    );
    setTotalPages(
      Math.ceil(
        filteredData.length / Number(sysConfig["Rows in MultiLine List"])
      )
    );

    if (totalPageCount !== 0 && totalPageCount < currentPage) {
      setCurrentPage(totalPageCount);
    }
  }, [reportData]);



  const setDefaultValue = () => { };

  const handleUserChange = (e) => {
    const type = e.target.value;
    setUserFilter(type);
  };
  const handleEntityChange = (e) => {
    const type = e.target.value;
    setEntityFilter(type);
  };

  const handleIsStatusChange = (e) => {
    setIsStatusFilter(e.target.value);
    refetch();

    // setDefaultValue();
  };
  const handleSearch = () => {

    const query = searchInput.current.value.toLowerCase();
    setSearchQuery(query);
    refetch();
    // setDefaultValue();
  };
  const filterData = (query) => {
    let filtered = reportData;

    if (query) {
      filtered = filtered.filter(
        (item) =>
          item?.ActionDscr?.toLowerCase().includes(query) ||
          item?.ChangeLog?.toLowerCase().includes(query)
      );
    }

    // if (user) {
    //   filtered = filtered.filter(
    //     (item) => item.ProjLead === user ||
    //       item.AllocBy === user ||
    //       item?.tasks_list.some(task => (task.TaskLead === user || task.AllocBy === user))
    //   );
    // }

    // if (status) {
    //   filtered = filtered.filter(
    //     (item) => item?.Status?.idx === parseInt(status)
    //   );
    // }

    setFilteredData(filtered);
    // setCurrentPage(1);
  };
  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
    setDefaultValue();
  };

  // ********************************************** get data start ****************************************************



  // ************************************************************* reset password modal **********************************

  const [confirmationShow, setConfirmationShow] = useState(false);
  const [funHandler, setFunHandler] = useState();
  const [changeUserFilter, setChangeUserFilter] = useState(true);
  const [taskStatusFilter, setTaskStatusFilter] = useState([]);
  const [reportStatusFilter, setReportStatusFilter] = useState([]);
  const [appliedFilter, setAppliedFilter] = useState({});
  const [entityType, setEntityType] = useState("task");
  const [reportStatus, setReportStatus] = useState("all");
  const [title, setTitle] = useState("Select Activity Filter");
  const buttonRef = useRef(null);
  const handleConfirmationClose = () => {
    setConfirmationShow(false);
  };
  const handleConfirmationShow = () => setConfirmationShow(true);


  useEffect(() => {
    let statusList
    if (watchedFields.entity === "task") {
      if (userInfo.user_type === "SysAdm") {

        statusList = [
          { key: "all", value: "All" },
          { key: "open", value: "Open" },
          { key: "overdue", value: "Overdue" },
          { key: "delayed", value: "Delayed" },
          { key: "completing", value: "Completing" },
          { key: "completed", value: "Completed" },
          { key: "task_totals", value: "Task Totals" },
        ]
      }
      else {

        statusList = [
          { key: "all", value: "All" },
          { key: "open", value: "Open" },
          { key: "overdue", value: "Overdue" },
          { key: "delayed", value: "Delayed" },
          { key: "completing", value: "Completing" },
          { key: "completed", value: "Completed" },
        ]
      }



    }
    else {
      statusList = [
        { key: "all", value: "All" },
        { key: "open", value: "Open" },
        { key: "overdue", value: "Overdue" },
        { key: "delayed", value: "Delayed" },

      ]

    }
    setReportStatusFilter(statusList)
  }, [watchedFields.entity, userInfo]);

  const [tranDataList, setTranDataList] = useState([]);

  const fetchTranList = async (type) => {
    // Perform the API call to fetch company info
    if (type !== "ALL") {

      try {
        const response = await getTableData(
          type
        );
        if (response?.status === 200) {
          setTranDataList(response?.data?.data ? response.data?.data : []);
        } else if (response?.response) {
          toast.error(response?.response?.data?.message);
        }
      } catch (error) {
        console.error("Error fetching data:", error); // Log any errors that occur
        throw error;
      }
    }
  };

  useEffect(() => {
    setValue("userFilter", userInfo?.user_code)
  }, [userInfo])
  useEffect(() => {
    const formatDateToInput = (date) => {
      const year = date.getFullYear();
      const month = String(date.getUTCMonth() + 1).padStart(2, '0'); // Months are zero-based
      const day = String(date.getUTCDate()).padStart(2, '0');
      return `${year}-${month}-${day}`;
    };
    const today = new Date();
    const thirtyDaysAgo = new Date();
    thirtyDaysAgo.setDate(today.getUTCDate() - 30);
    setValue("startDate", formatDateToInput(thirtyDaysAgo))
    setValue("endDate", formatDateToInput(today))
  }, [])
  useEffect(() => {
    fetchTranList(2)
  }, [])

  return (
    <div id="app-content">
      {/* Container fluid */}
      <div className="app-content-area">
        <div className="container-fluid">
          <div className="row">
            <div className="col-lg-12 col-md-12 col-12">
              {/* Page header */}
              <div className="mb-5">
                <h3 className="mb-0 ">
                  User Activity
                </h3>
              </div>
            </div>
          </div>
          <div>
            {/* row */}
            <div className="row">
              <div className="col-12">
                {/* card */}
                <div className="card mb-4">
                  <div className="card-header  ">

                    <>
                      <div className="accordion mb-4 " id="accordionExample">
                        <div className="accordion-item ">
                          <h2 className="accordion-header bg-white" id="headingOne">
                            <button className="accordion-button" type="button" data-bs-toggle="collapse" ref={buttonRef}
                              data-bs-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
                              <strong>
                                {title}
                              </strong>
                            </button>
                          </h2>
                          <div id="collapseOne" className="accordion-collapse collapse show p-3"
                            aria-labelledby="headingOne" data-bs-parent="#accordionExample">
                            <form onSubmit={handleSubmit(onSubmit)} >

                              <div className="row justify-content-between">




                                <div className="col-lg-4 col-md-4 col-6   mt-md-3">
                                  <label className="form-label">
                                    User{" "}
                                    <span className="text-danger">*</span>
                                  </label>
                                  {(
                                    // <select
                                    //   className="form-select mb-4"
                                    //   aria-label="Default select example"
                                    //   disabled={!isAdmin(userInfo)}
                                    //   value={watchedFields.userFilter}
                                    //   {...register("userFilter", {
                                    //     onChange: (e) => {
                                    //       if (e.target.value === "ALL") {
                                    //         setValue("byOrToMe", "ALL")
                                    //       }
                                    //     }
                                    //   })}
                                    // >
                                    //   <option disabled>Select User</option>

                                    //   <option selected="" value={"ALL"}>
                                    //     All
                                    //   </option>
                                    //   {userList.map((item) => (
                                    //     <option value={item}>{item}</option>
                                    //   ))}
                                    // </select>
                                    <Select
                                      // className="form-select"
                                      styles={customStyles}
                                      value={watchedFields.userFilter ? { label: watchedFields.userFilter === "all" ? "All" : watchedFields.userFilter, value: watchedFields.userFilter } : { label: "All", value: "all" }}
                                      isDisabled={!isAdmin(userInfo)}
                                      placeholder="Select user."
                                      // onChange={handleUserChange}
                                      onChange={(option) => {
                                        setValue("userFilter", option.value)
                                       
                                      }}

                                      options={[{ label: "Select a user", value: "Select a user", isDisabled: true }, { label: "All", value: "ALL" }, ...convertToUserOptions(userList)]}
                                    />
                                  )}
                                </div>

                                {/* form group */}
                                <div className=" col-lg-4  col-md-4 col-6 mt-md-3">
                                  <label className="form-label">
                                    Start date{" "}
                                    <span className="text-danger">*</span>
                                  </label>
                                  <div
                                    className="input-group me-3 flatpickr rounded flatpickr-input"
                                    readOnly="readonly"
                                  >
                                    <input
                                      className="form-control "
                                      type="date"
                                      placeholder="Select Date"
                                      aria-describedby="basic-addon2"
                                      format="dd/mm/yyyy"

                                      min="1000-01-01T00:00"
                                      max="9999-12-31T23:59"
                                      {...register("startDate", {
                                        // required: "Start Date is required",

                                      })}
                                    />
                                  </div>
                                  {errors.startDate && (
                                    <div className="error">
                                      {errors.startDate.message}
                                    </div>
                                  )}
                                </div>
                                {/* form group */}
                                <div className=" col-lg-4  col-md-4 col-6 mt-md-3">
                                  <label className="form-label">
                                    End Date{" "}
                                    <span className="text-danger">*</span>
                                  </label>
                                  <div
                                    className="input-group me-3 flatpickr rounded flatpickr-input"
                                    readOnly="readonly"
                                  >
                                    <input
                                      className="form-control "
                                      type="date"
                                      placeholder="dd-mm-yyyy"
                                      //  pattern="\d{2}-\d{2}-\d{4}"

                                      min="1000-01-01T00:00"
                                      max="9999-12-31T23:59"

                                      {...register("endDate", {
                                        // required: "End Date is required",

                                      })}
                                    />
                                  </div>
                                  {errors.endDate && (
                                    <div className="error">
                                      {errors.endDate.message}
                                    </div>
                                  )}
                                </div>
                                <div className="col-lg-4 col-md-4 col-6   mt-md-3">
                                  <label className="form-label">
                                    Action Type{" "}
                                    <span className="text-danger">*</span>
                                  </label>
                                  {(
                                    <select
                                      className="form-select mb-4"
                                      aria-label="Default select example"
                                      {...register("actionType"
                                      )}
                                    >
                                      <option disabled>Select Action</option>
                                      <option selected value={"ALL"}>All</option>
                                      {ACTION_TYPE.map((item) =>
                                        <option value={item.id} >{item.value}</option>
                                      )}
                                    </select>
                                  )}
                                </div>
                                <div className="col-lg-4 col-md-4 col-6   mt-md-3">
                                  <label className="form-label">
                                    Entity Type{" "}
                                    <span className="text-danger">*</span>
                                  </label>
                                  {(
                                    <select
                                      className="form-select mb-4"
                                      aria-label="Default select example"
                                      {...register("entityType", {
                                        onChange: (e) => {
                                          fetchTranList(e.target.value)
                                          if (e.target.value === "ALL") {
                                            setValue("entityId", 0)
                                          }
                                        }
                                      })}
                                    >
                                      <option disabled>Select Entity</option>
                                      <option selected value={"ALL"}>All</option>
                                      {ENTITY_TYPE.map((item) =>
                                        <option value={item.id} >{item.value}</option>
                                      )}
                                    </select>
                                  )}
                                </div>
                                <div className="col-lg-4 col-md-4 col-6   mt-md-3">
                                  <label className="form-label">
                                    Entity Id{" "}
                                    <span className="text-danger">*</span>
                                  </label>
                                  <input
                                    type="number"
                                    min="0"
                                    className="form-control "
                                    placeholder="Enter Entity Id"
                                    disabled={watchedFields.entityType === "ALL"}

                                    {...register("entityId", {
                                      // required: "Approx Days is required",
                                      // onChange: (e) => {
                                      //   onDateOrDurationChange(
                                      //     e.target.value,
                                      //     "day"
                                      //   );
                                      // },
                                    })}
                                  />
                                  {errors.entityId && (
                                    <div className="error">
                                      {errors.AprxDays.entityId}
                                    </div>
                                  )}
                                </div>
                                {/* <div className="col-lg-4 col-md-4 col-6   mt-md-3">
                                  <label className="form-label">
                                    Entity Id{" "}
                                    <span className="text-danger">*</span>
                                  </label>

                                  {(
                                    <select
                                      className="form-select mb-4"
                                      aria-label="Default select example"
                                      {...register("entityId"

                                      )}
                                      disabled={watchedFields.entityType === "ALL"}
                                    >
                                      <option disabled >Select Entity Id</option>
                                      <option selected value={0}>All</option>
                                      {tranDataList.length
                                        ? tranDataList.map((item) => (
                                          <option value={item?.ID ? item.ID : item}>
                                            {item?.Name ? item.Name : item}
                                          </option>
                                        ))
                                        : ""}

                                    </select>
                                  )}
                                </div> */}
                              </div>
                              <div className="row mt-4 p-3 justify-content-center">
                                <button className="btn btn-primary col-12 col-lg-2"> Apply</button>
                              </div>
                            </form>
                          </div>
                        </div>
                      </div>
                      {appliedFilter.reportStatus !== "task_totals" &&
                        <div className=" col-lg-12 col-md-12 mt-md-3 d-flex ">
                          <input
                            ref={searchInput}
                            type="search"
                            className="form-control "
                            // value={searchQuery}
                            onChange={(e) => {
                              if (e.target.value === "") {
                                handleSearch();
                              }
                            }}
                            placeholder="Search by Description & Change Log."
                          />
                          <div
                            className="btn btn-primary ms-3"
                            onClick={() => handleSearch()}
                          >
                            <IoMdSearch size={25} />
                          </div>
                        </div>}



                    </>
                  </div>
                  {!isLoading ? (
                    <>
                      {(currentItems.length > 0) && <div className="d-flex justify-content-end ">
                        {appliedFilter.reportStatus === "task_totals" ?
                          <div className="btn btn-primary col-lg-2 col-md-4 m-4" onClick={() => generateActiveLogExcel(filteredData, reportStatus, appliedFilter, userInfo)} >Export to xlsx</div> :
                          <div className="btn btn-primary col-lg-2 col-md-4 m-4" onClick={() => generateActiveLogExcel(filteredData, reportStatus, appliedFilter, userInfo)} >Export to xlsx</div>
                        }
                      </div>}
                      <div className="card-body">
                        <div className="table-responsive table-card">
                          {currentItems.length > 0 ? (
                            <>

                              <table className="table text-nowrap mb-0 responsive-table table-centered table-hover">
                                <thead className="table-light">
                                  <tr>
                                    <th className="   ">
                                      Srl
                                    </th>
                                    <th className="   ">
                                      Date Time
                                    </th>
                                    <th className=" pe-0  ">
                                      Staff Code
                                    </th>
                                    <th className="">
                                      Action Type
                                    </th>
                                    <th className="">
                                      Action Description
                                    </th>
                                    <th className="">
                                      Entity Type
                                    </th>
                                    <th className="">
                                      Entity ID
                                    </th>
                                    <th className="">
                                      Change Log
                                    </th>
                                    <th className="">
                                      Device IP
                                    </th>
                                    <th className="">
                                      Device Name
                                    </th>

                                  </tr>
                                </thead>

                                <tbody>
                                  {currentItems.map((item, index) => (
                                    <tr
                                      id={`user-${index}`}
                                      className={""}
                                    >
                                      <td
                                        data-label1="Srl"

                                      >
                                        {index + 1}
                                      </td>
                                      <td data-label1="Date Time" >
                                        {item?.ActionDtTm ? formatDateTimetoAmPm(item?.ActionDtTm) : "--"}
                                      </td>
                                      <td data-label1="Staff Code" >
                                        {item?.StaffCode}
                                      </td>
                                      <td data-label1="Action Type" >
                                        {item?.ActionType}
                                      </td>
                                      <td
                                        data-label1="Action"
                                        data-label2="Description"
                                        // className="name"
                                        style={{
                                          maxWidth: "350px",
                                          minWidth: "220px",
                                          textWrap: "wrap",
                                        }}
                                      >
                                        <div className="d-flex flex-column truncate">
                                          {item?.ActionDscr}
                                        </div>
                                      </td>
                                      <td data-label1="Entity Type" >
                                        {getEntityValueById(item?.EntityType) === "ALL" ? "--" : getEntityValueById(item?.EntityType)}
                                      </td>
                                      <td data-label1="Entity Id" >
                                        {item?.EntityID}
                                      </td>
                                      <td data-label1="Change Log" style={{
                                        maxWidth: "350px",
                                        minWidth: "220px",
                                        textWrap: "wrap",
                                      }} >
                                        <div className="d-flex flex-column truncate">
                                          {item?.ChangeLog ? item.ChangeLog : "--"}
                                        </div>
                                      </td>
                                      <td data-label1="Device IP" >
                                        {item?.FromIP}
                                      </td>

                                      <td data-label1="Device Name" >
                                        {item?.FromDeviceNm}
                                      </td>




                                    </tr>
                                  ))}
                                </tbody>
                              </table>

                            </>

                          ) : (
                            <div className="m-5 fs-3">
                              <strong>No records found.!</strong>
                            </div>
                          )}
                        </div>
                      </div>
                      {filteredData.length > 0 && appliedFilter.reportStatus !== "task_totals" && (
                        <div className="card-footer d-md-flex justify-content-between align-items-center">
                          <span>
                            Showing{" "}
                            {currentPage *
                              Number(sysConfig["Rows in MultiLine List"]) -
                              Number(sysConfig["Rows in MultiLine List"]) +
                              1}{" "}
                            to{" "}
                            {currentPage *
                              Number(sysConfig["Rows in MultiLine List"]) >=
                              filteredData.length
                              ? filteredData.length
                              : currentPage *
                              Number(
                                sysConfig["Rows in MultiLine List"]
                              )}{" "}
                            of {filteredData.length} entries
                          </span>
                          <nav className="mt-2 mt-md-0">
                            <ul className="pagination mb-0 ">
                              <li
                                className="page-item "
                                style={{ cursor: "pointer" }}
                                onClick={() => {
                                  if (currentPage > 1) {
                                    handlePageChange(currentPage - 1);
                                  }
                                }}
                              >
                                <div
                                  className={`page-link ${currentPage === 1 ? "disabled" : ""
                                    } `}
                                >
                                  Previous
                                </div>
                              </li>
                              {Array(totalPages ? totalPages : 0)
                                .fill()
                                .map((item, index) => (
                                  <li
                                    style={{ cursor: "pointer" }}
                                    className={`${currentPage === index + 1
                                      ? "page-item active"
                                      : "page-item"
                                      } ${currentPage + 2 >= index + 1 &&
                                        index + 1 > currentPage - 2
                                        ? // currentPage - 2 < index + 1
                                        "d-block"
                                        : "d-none"
                                      }`}
                                    onClick={() => {
                                      handlePageChange(index + 1);
                                    }}
                                  >
                                    <div className="page-link">{index + 1}</div>
                                  </li>
                                ))}

                              <li className="page-item">
                                <div
                                  style={{ cursor: "pointer" }}
                                  className={`page-link ${totalPages === currentPage ? "disabled" : ""
                                    } `}
                                  onClick={() => {
                                    if (totalPages > currentPage) {
                                      handlePageChange(currentPage + 1);
                                    }
                                  }}
                                >
                                  Next
                                </div>
                              </li>
                            </ul>
                          </nav>
                        </div>
                      )}
                    </>
                  ) : (
                    <div className="m-5 fs-3">
                      <strong>Fetching records..</strong>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <ConfirmationModal
        show={confirmationShow}
        onHide={handleConfirmationClose}
        funHandler={funHandler}
      />
    </div>
  );
};

export default UserActivity;
